import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ButtonComponent } from '@hs/ui-core-inputs';
import { IconComponent } from '@hs/ui-core-presentation';

import { ButtonLabel, DashboardNote, emptyNote } from '../../../models/dashboard-note';

@Component({
    selector: 'ddv-dashboard-note',
    templateUrl: 'dashboard-note.component.html',
    styleUrls: ['dashboard-note.component.scss'],
    imports: [
        IconComponent,
        ButtonComponent,
    ],
})
export class DashboardNoteComponent implements OnChanges {
    @Input() note: DashboardNote = emptyNote();

    @Output() acknowledge = new EventEmitter<void>();

    protected buttonLabel: ButtonLabel | undefined;
    protected title: string | undefined;
    protected notes: string[] = [];

    ngOnChanges(): void {
        this.buttonLabel = this.note.buttonLabel;
        this.title = this.note.title;
        this.notes = this.note.message.split('\n');
    }
}
